import Block from "@/components/wrappers/block"
import NumberFocus from "../number-focus/number-focus"
import styles from "./flowerfieldNumbers.module.css"

export default function FlowerfieldNumbers({ block }) {
  block.innerBlocks = block.attrs.numbers
  return (
    <Block block={block}>
      <h2 className={styles.heading}>{block.attrs.headline}</h2>
      <NumberFocus block={block}></NumberFocus>
    </Block>
  )
}
